"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCROLL_OPTIONS = void 0;
// eslint-disable-next-line no-undef
exports.SCROLL_OPTIONS = {
    block: 'nearest',
    behavior: 'smooth',
    inline: 'nearest',
};
